
define('template!shareCreateEditLayoutTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="detailed-info-form-container">\n  <div class="saving-label"></div>\n  <div class="error-label">' +
((__t = ( _.i18n('common.serverError') )) == null ? '' : __t) +
'\n      <div class="error-msg">  </div>\n  </div>\n  <div class="form-horizontal">\n    <div class="form-inputs-container">\n      <div class="form-group" data-field-name="comment">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.comment') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <textarea class="form-control floating-label js-info-input" rows="4" data-field-name="comment" placeholder="' +
((__t = ( _.i18n('common.comment') )) == null ? '' : __t) +
'">' +
((__t = ( comment )) == null ? '' : __t) +
'</textarea>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="orderEmail">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.orderEmail') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="orderEmail" value="' +
((__t = ( orderEmail )) == null ? '' : __t) +
'" placeholder="' +
((__t = ( _.i18n('common.orderEmail') )) == null ? '' : __t) +
'"></input>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="website">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.webSite') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="website" value="' +
((__t = ( website )) == null ? '' : __t) +
'" placeholder="' +
((__t = ( _.i18n('common.webSite') )) == null ? '' : __t) +
'"></input>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="orderByEmail">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.orderByEmail') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="checkbox" data-field-name="orderByEmail" class="orderByEmail checkbox-input" ' +
((__t = ( orderByEmail ? 'checked':'')) == null ? '' : __t) +
'>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="phone">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.phone') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="phone" value="' +
((__t = ( phone )) == null ? '' : __t) +
'" placeholder="' +
((__t = ( _.i18n('common.phone') )) == null ? '' : __t) +
'"></input>\n        </div>\n      </div>\n      <div class="form-group" data-field-name="orderComment">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.orderComment') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9">\n          <textarea class="form-control floating-label js-info-input" rows="4" data-field-name="orderComment" placeholder="' +
((__t = ( _.i18n('common.orderComment') )) == null ? '' : __t) +
'">' +
((__t = ( orderComment )) == null ? '' : __t) +
'</textarea>\n        </div>\n      </div>\n      <div class="row">\n        <div class="pull-right p-r-15">\n          <button class="btn btn-default btn-flat cancel-b js-cancel-popup">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n          <button disabled class="btn btn-primary disabled-grey js-confirm">' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

